import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import s from './Refunds.css';
import refundRequestsQuery from './refundRequestsQuery.graphql';
import RefundsList from '../../../components/SiteAdmin/RefundsList/RefundsList';
import Loader from '../../../components/Common/Loader/Loader';
import messages from '../../../locale/messages';

// The refund queue: customer requests awaiting review, in-flight dispatches,
// and stuck rows needing retry/resolution — all read from (and acted on via)
// asap-super-api's refund engine through this backend's proxy resolvers.
export class Refunds extends Component {

    render() {
        const { refundRequests, refundRequests: { loading } } = this.props;

        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    <div className={s.container}>
                        <div className={cx(s.heading, 'textAlignRightRTL')}>
                            <FormattedMessage {...messages.manageRefunds} />
                        </div>
                        <div className={s.paddingRoutesSection}>
                            {!loading && <RefundsList refundRequests={refundRequests} />}
                        </div>
                    </div>
                </div>
            </Loader>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(refundRequestsQuery, {
        name: 'refundRequests',
        options: () => ({
            variables: {
                currentPage: 1,
            },
            fetchPolicy: 'network-only',
            ssr: false,
        })
    }),
)(Refunds);
